export default function SectionHeading({ eyebrow, title, copy, className = "", headingAs: Heading = "h2" }) {
  const classes = ["public-section__header", className].filter(Boolean).join(" ");

  return (
    <div className={classes}>
      <Heading className="public-section__title">{title}</Heading>
      {copy ? <p className="public-section__copy">{copy}</p> : null}
    </div>
  );
}
